import React from 'react';
import PropTypes from 'prop-types';
import dateFormatService from '../services/DateFormatService';
import momentPropTypes from 'react-moment-proptypes';
import moment from 'moment';

const FormattedDayMonth = ({ value }) => {
  const stringValue =
    value instanceof Date
      ? value.toISOString()
      : moment.isMoment(value)
      ? value.toISOString()
      : value;

  return <span>{dateFormatService.formatDayMonth(stringValue)}</span>;
};

FormattedDayMonth.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    momentPropTypes.momentObj,
  ]).isRequired,
};

export default FormattedDayMonth;
